





import { Component, Vue } from 'vue-property-decorator'
import * as shareApi from '../api/shareApi'
import { env } from '@ivy/fts/envInfo/envInfo'

@Component
export default class extends Vue {
  async mounted() {
    await env.init()
    env.type === 'wx' && (await shareApi.share())
  }
}
